const checkShopifyReinstall = (message) => {
	return (
		typeof message === "string" &&
		message.toLowerCase().indexOf("install the app again") !== -1
	);
};

export default checkShopifyReinstall;
